










import { Vue, Component } from 'vue-property-decorator';
import Streamax from './Streamax.vue';
@Component({
  components: { Streamax },
})
export default class ConfiguracionCamaras extends Vue {
  moduleType: string = '';
  created() {
    var self = this;
  }
  mounted() {
    this.changedModule();
  }
  changedModule() {
    let url = new URL(window.location.href);
    this.moduleType =
      url.pathname != '/configuracionCamarasStreamax'
        ? 'Configuración Cámaras'
        : 'Configuración Cámaras';
  }
}
